import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    label: string;
    name: string;
    data?: any[];
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: any;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: string | never[] | string[] | undefined;
    disabled?: false | boolean;
    onChangeValue: (event: string[]) => void;
    reasonEnabled?: false | boolean;
    onReason?: any;
};

const MultipleAutocompleteField = ({
    label,
    name,
    data,
    size,
    margin,
    required,
    value,
    touched,
    errors,
    disabled,
    onChangeValue,
    reasonEnabled,
    onReason,
}: Props) => {
    //onChangeValue Formik
    //The variable MultipleAtocompleteFormik must be equal to the variable name of the formik
    //onChangeValue={(value) => formik.setFieldValue('MultipleAtocompleteFormik', value)}

    const [valuesItem, setValuesItems] = useState<any[]>([]);

    useEffect(() => {
        const isString = value && typeof value[0] === 'string';
        const newValue =
            value && isString
                ? value || []
                : (value || []).map((item: any) => item.id);
        setValuesItems(
            (data || []).filter((item) =>
                newValue.includes(item.code || item.id)
            )
        );
    }, [value]);

    return (
        <>
            <Autocomplete
                multiple={true}
                id="tags-outlined"
                options={Array.isArray(data) ? data : []}
                disabled={disabled}
                value={valuesItem}
                onChange={(event: any, newValue: any | null) => {
                    setValuesItems(newValue || []);
                    onChangeValue(newValue || []);
                }}
                onInputChange={(_: any, e: string | null, reason) => {
                    if (reasonEnabled) {
                        onReason(reason);
                    }
                }}
                getOptionLabel={(option) => option.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        name={name}
                        size={size}
                        margin={margin}
                        required={required}
                        helperText={touched ? errors : ''}
                        error={touched && Boolean(errors)}
                        sx={{
                            '& label.Mui-focused': {
                                color: 'primary.main',
                            },
                            '& .MuiInput-underline:after': {
                                borderBottomColor: 'primary.main',
                            },
                            '& .MuiFilledInput-underline:after': {
                                borderBottomColor: 'primary.main',
                            },
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: 'primary.main',
                                },
                            },
                        }}
                    />
                )}
            />
        </>
    );
};

export default MultipleAutocompleteField;
